import { getEnvironmentVariable } from './environment.loader';

export const environment = {
  production: true,
  modaAPI: getEnvironmentVariable('api-moda', 'http://develop.engenharia-vd.totvs.io:15200/api/totvsmoda/'),
  clientIdAuthAPI: 'totvs_vd_analytics_cce08e9fc9c7416199466f3b2a69e871',
  clientSecretAuthAPI: 'fc41976252fd4107951a3de9364da06d',
  urlAnalyticsAPI: getEnvironmentVariable('api-url', 'http://develop.engenharia-vd.totvs.io:15200/api/totvsmoda/'),
};